export default "__VITE_ASSET__Bf9GFsDu__"